import { call, put, takeLatest } from 'redux-saga/effects';
import HeroSupportAPI from 'api-services/HeroSupportApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { SEND_TICKET } from './actionTypes';
import { sendTicketDone, sendTicketError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* sendTicketCall(constAccessParams, action) {
    const { subject, message } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroSupportAPI.sendTicket, newAccessParams, subject, message);
    if (isSuccessResponse(result)) {
        yield put(sendTicketDone());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(sendTicketError(result));
    }
}
export function* watchSendTicketCall(constAccessParams) {
    yield takeLatest(SEND_TICKET, sendTicketCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map